import styled from 'styled-components';
import { PriceFilterInput } from 'components/PriceFilterInput';

export const PriceFilter = styled(PriceFilterInput)`
  margin-left: 8px;
`;
